import { cn } from "@/lib/utils";

export function SectionHeading({ title, description, className }) {
  return (
    <div className={cn("flex flex-col items-start gap-5", className)}>
      <h2 className="relative text-4xl sm:text-6xl font-medium tracking-tight text-neutral-900">
        {title}
        <span className="from-[#ff9966] to-[#ffc53d] absolute -bottom-2 start-0 h-1 w-full rounded-full bg-linear-to-r" />
      </h2>
      {description && (
        <p className="text-lg sm:text-xl text-neutral-600 max-w-2xl text-pretty">
          {description}
        </p>
      )}
    </div>
  );
}
